export default "__VITE_ASSET__C2BpFc0H__"